import { writable } from 'svelte/store';

export const saveEnergyStore = writable(false);
